const { default: initCopyButton } = require("./copy-to-clipboard");
const { default: eventListModal } = require("./event-list-modal");
const { default: mobileMenu } = require("./mobile-menu");
const { default: modal } = require("./modal");
const { default: timetableTabs } = require("./timetableTabs");

mobileMenu();
modal();
eventListModal();
timetableTabs();
initCopyButton();

(function (){
    const header = document.querySelector("header");
    const miniHeaderElements = header.querySelectorAll('.js-display-when-mini');
    const largeHeaderElements = header.querySelectorAll('.js-hide-when-mini');
    const scrollAmount = window.innerWidth <= 768 ? 16 : 24;
    function scrollEvent() {
        header.classList.toggle("is-mini", window.scrollY > scrollAmount);
        miniHeaderElements.forEach((element) => {
        element.toggleAttribute('inert', window.scrollY <= scrollAmount);
        });
        largeHeaderElements.forEach((element) => {
        element.toggleAttribute('inert', window.scrollY > scrollAmount);
        });
    }
    scrollEvent();
    window.addEventListener("scroll", scrollEvent);
})();

// Set up scrollbar width css variable
(function(){
    const root = document.documentElement;
    root.style.setProperty('--scrollbar-width', getScrollbarWidth()+'px');

    function getScrollbarWidth() {

        // Creating invisible container
        const outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll'; // forcing scrollbar to appear
        outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
        document.body.appendChild(outer);
      
        // Creating inner element and placing it in the container
        const inner = document.createElement('div');
        outer.appendChild(inner);
      
        // Calculating difference between container's full width and the child width
        const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
      
        // Removing temporary elements from the DOM
        outer.parentNode.removeChild(outer);
      
        return scrollbarWidth;
      
      }
})();